var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('router-view',{attrs:{"project":_vm.project},on:{"update:project":function($event){_vm.project=$event}}}):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }